import { render, staticRenderFns } from "./simpleControl.vue?vue&type=template&id=b13d2768&scoped=true&"
import script from "./simpleControl.vue?vue&type=script&lang=js&"
export * from "./simpleControl.vue?vue&type=script&lang=js&"
import style0 from "./simpleControl.vue?vue&type=style&index=0&id=b13d2768&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13d2768",
  null
  
)

export default component.exports